// extracted by mini-css-extract-plugin
module.exports = {"buttonMultiply":"_1TYxF"};